import FSProduct from '~/js/models/FSProduct'
import { getQueryParams } from '~/js/helpers/url-helper'
import JSONP from 'jsonp'

const ID_HEADER = 'js-snippetsHeader'

export const getFSFilteredProducts = async ({
  collectionId,
  productSort,
  limit,
  page = 1,
  callback,
}) => {
  return new Promise((resolve, _) => {
    const elementHeader = document.getElementById(ID_HEADER)
    const shopDomain = elementHeader.dataset.shopDomain

    const paramString = getQueryParams(
      {
        collection: collectionId,
        shop: shopDomain,
        ...(productSort ? { sort_by: productSort } : {}),
        limit,
        page,
        'excludeTags[]': 'algolia-ignore',
        country: 'JP',
        event: 'products',
        callback, // コールバック関数名を指定
      },
      true
    )

    // JSONPリクエスト
    JSONP(
      `https://filter-v3.globosoftware.net/filter?${paramString}`,
      null,
      (err, data) => {
        if (err) {
          console.error('Globo API error:')
          resolve({ products: [], pagination: null })
        } else {
          const products = data.products
            .filter((p) => !p.handle.includes('shoguntemp'))
            .map((p) => new FSProduct(p))
          resolve({ products, pagination: data.pagination }) // データ取得成功時にPromiseをresolveする
        }
      }
    )
  })
}

export const getFSSearchedProducts = async ({ searchKeyword, callback }) => {
  return new Promise((resolve, _) => {
    const elementHeader = document.getElementById(ID_HEADER)
    const shopDomain = elementHeader.dataset.shopDomain

    const paramString = getQueryParams(
      {
        term: searchKeyword,
        shop: shopDomain,
        sort: 'relevance',
        'excludeTags[]': 'algolia-ignore',
        country: 'JP',
        callback, // コールバック関数名を指定
      },
      true
    )

    // JSONPリクエスト
    JSONP(
      `https://filter-v3.globosoftware.net/search?${paramString}`,
      null,
      (err, data) => {
        if (err) {
          console.error('Globo API error:')
          resolve({ products: [] })
        } else {
          const { result } = data
          const products = (result.products || [])
            .filter((p) => !p.handle.includes('shoguntemp'))
            .map((p) => new FSProduct(p))
          resolve({ ...result, products })
        }
      }
    )
  })
}
